import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=26984cf0&"
import script from "./notfound.vue?vue&type=script&lang=ts&"
export * from "./notfound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports